import { CircleX, Linkedin, Slack } from 'lucide-react';
import React from 'react';

import { Avatar, AvatarFallback } from '@/modules/ui/components/avatar/Avatar';

interface UserExternalAccountAvatarProps {
  type: string;
}

export const UserExternalAccountAvatar: React.FC<
  UserExternalAccountAvatarProps
> = ({ type }) => {
  let icon, backgroundColor;
  switch (type) {
    case 'LinkedIn':
      icon = <Linkedin size={20} />;
      backgroundColor = '#0077b5';
      break;
    case 'Slack':
      icon = <Slack size={20} />;
      backgroundColor = '#4a154b';
      break;
    default:
      icon = <CircleX size={20} />;
      backgroundColor = '#d9d9d9';
  }
  return (
    <Avatar style={{ backgroundColor }}>
      <AvatarFallback style={{ backgroundColor }}>{icon}</AvatarFallback>
    </Avatar>
  );
};
